import { TableSortLabel } from "@mui/material"
import type { FC, ReactNode } from "react"

import { type InventoryPalletGroupsSortField, SortingOrder } from "@/graphql/codegen/graphql"

export interface InventoryPalletTableSort {
  sortBy: InventoryPalletGroupsSortField
  sortDirection: SortingOrder
  onSortChange: (field: InventoryPalletGroupsSortField, direction: SortingOrder) => void
}

const sortLabelSx = {
  "&.Mui-active": { color: "inherit" },
  "& .MuiTableSortLabel-icon": { color: "inherit !important" },
} as const

interface InventoryPalletTableSortLabelProps {
  field: InventoryPalletGroupsSortField
  label: ReactNode
  sort: InventoryPalletTableSort
}

export const InventoryPalletTableSortLabel: FC<InventoryPalletTableSortLabelProps> = ({ field, label, sort }) => {
  const { sortBy, sortDirection, onSortChange } = sort
  const isActive = sortBy === field
  const sortDirectionLabel = sortDirection === SortingOrder.Asc ? "asc" : "desc"

  const handleClick = () => {
    let newSortDirection = SortingOrder.Asc

    if (field === sortBy) {
      newSortDirection = sortDirection === SortingOrder.Asc ? SortingOrder.Desc : SortingOrder.Asc
    }

    onSortChange(field, newSortDirection)
  }

  return (
    <TableSortLabel
      sx={sortLabelSx}
      active={isActive}
      direction={isActive ? sortDirectionLabel : "asc"}
      onClick={handleClick}
    >
      {label}
    </TableSortLabel>
  )
}
